<template>
  <div class="student_report_shengya">
    <div class="rzqn xljk">
      <div class="rzqnTitle">
        心理健康评估结果与常模对比结果
      </div>
      <table>
          <tbody>
            <tr>
              <th rowSpan="2">心理健康</th>
              <th rowSpan="2">心理健康水平值</th>
              <th rowSpan="2">常模范围</th>
              <th width="350" colSpan="5">得分</th>
            </tr>
            <tr>
              <th width="70">1</th>
              <th width="70">2</th>
              <th width="70">3</th>
              <th width="70">4</th>
              <th width="70">5</th>
            </tr>
          </tbody>
          <tr v-for="(item,key) in norm">
            <td class="blue">{{item.name}}</td>
            <td>{{item.score}}</td>
            <td>{{item.lnorm}}-{{item.rnorm}}</td>
            <td colspan="5">
              <div :style="{
                 width:item.score/5*350+'px'
                }"
                 :class="
                    item.score<=1&&'b-red'||
                    item.score>1&&item.score<=2&&'b-orange'||
                    item.score>2&&item.score<=3&&'b-yellow'||
                    item.score>3&&item.score<=4&&'b-green'||
                    item.score>4&&'b-blue'
                  "
              >
                <div class='op' :style="{left:item.lnorm/5*350+'px',width:(item.rnorm-item.lnorm)/5*350+'px'}"></div>
              </div>

            </td>
          </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "rgtx",
  props:['reportId'],
  data(){
    return {
      norm:{},
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_report + this.ports.consultant.student.report.xljk,{
        report_id:this.reportId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==0){
            const{norm}=res.data.result
            this.norm=norm;
        }else{
        }
      })
    }
  },
  mounted() {
    this.getData()
  },
}
</script>
<style lang="less" scoped>
@import '../../css/evaluationReport.less';
</style>